import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { AccountsGridBaseDataProvider } from '../dataProvider/AccountsGridBaseDataProvider';

export class AccountsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_GZ, AccountsGridBaseDataProvider);
  }
}
